import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import Global from '../../../store/global-selectors';

const name = <FormattedMessage {...messages.productProfileIdColumnHeader} />;

const ProductProfile = ({ productProfileId }) => {
  const productProfile = useSelector((state) => Global.selectEntitiesProductProfileById(state, { productProfileId }));

  return productProfile?.name ?? '';
};

export default {
  getMessageDescriptor: () => messages.productProfileIdColumnHeader,
  name,
  render: (data) => <ProductProfile productProfileId={data.productProfileId} />,
};
